<template>
  <div style="padding: 20px; height: 100%">
    <el-form :inline="true" class="demo-form-inline">
      <div class="df aic">
        <el-form-item size="medium" class="mr10" style="flex: 0 0 16%">
          <el-input
            placeholder="终端ID"
            v-model="query.terminal_id"
            clearable
            class="input-with-select"
            @clear="onSubmit"
          >
          </el-input>
        </el-form-item>
        <el-form-item size="medium" class="mr10" style="flex: 0 0 16%">
          <el-input
            placeholder="盒子名称"
            v-model="query.box_name"
            clearable
            class="input-with-select"
            @clear="onSubmit"
          >
          </el-input>
        </el-form-item>
        <el-button
          type="success"
          size="medium"
          @click="onSubmit"
          class="mr10"
          style="height: 36px; border: none !important; margin-bottom: 20px"
          >查询</el-button
        >
        <el-button
          type="primary"
          size="medium"
          class="mr10"
          style="height: 36px; border: none !important; margin-bottom: 20px"
          @click="add"
          >新增</el-button
        >
      </div>
    </el-form>
    <el-table :data="list" style="width: 100%">
      <el-table-column
        prop="terminal_id"
        label="终端ID"
        width="450"
        align="center"
      >
      </el-table-column>
      <el-table-column prop="box_name" label="盒子名称" align="center">
      </el-table-column>
      <el-table-column
        prop="company_name"
        label="企业名称"
        width="300"
        align="center"
      >
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="disib"
            size="mini"
            @click="handleEdit(scope.row)"
            >修改</el-button
          >
          <el-button
            type="text"
            class="disib red"
            size="mini"
            @click="delItem(scope.row)"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>
    <div class="df" style="justify-content: flex-end; padding: 20px 0">
      <el-pagination
        background
        :page-size="query.limit"
        layout="total,prev, pager, next"
        :total="total"
        :current-page="query.page"
        @current-change="pageChange"
      >
      </el-pagination>
    </div>
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="50%"
      @closed="resetForm"
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item
          label="终端ID"
          prop="terminal_id"
          :rules="{
            required: true,
            message: '终端ID不能为空',
            trigger: 'blur',
          }"
        >
          <el-input
            placeholder="终端ID"
            v-model="form.terminal_id"
            clearable
            style="width: 60%; float: left"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="盒子名称"
          prop="box_name"
          :rules="{
            required: true,
            message: '盒子名称不能为空',
            trigger: 'blur',
          }"
        >
          <el-input
            placeholder="盒子名称"
            v-model="form.box_name"
            clearable
            style="width: 60%; float: left"
          >
          </el-input>
        </el-form-item>
        <el-form-item
          label="企业名称"
          prop="company_id"
          :rules="{
            required: true,
            message: '请选择企业',
            trigger: 'change',
          }"
        >
          <el-autocomplete
            placeholder="企业名称"
            v-model="form.company_name"
            value-key="company_name"
            :fetch-suggestions="querySearchAsync"
            clearable
            style="width: 60%; float: left"
            @input="clearCompany"
            @select="handleSelect"
          >
            <template slot-scope="{ item }">
              <span class="name">{{ item.company_name }}</span>
              <span
                class="addr"
                style="font-size: 12px; color: silver; float: right"
                >{{ item.credit_code }}</span
              >
            </template>
          </el-autocomplete>
        </el-form-item>
        <el-form-item>
          <div
            class="df"
            style="justify-content: flex-end; width: 88.5%; margin-top: 10px"
          >
            <el-button
              type="success"
              size="medium"
              style="height: 40px; border: none !important; margin-left: 20px"
              @click="submit"
              >提交</el-button
            >
          </div>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import axios from "@/util/api";

export default {
  data() {
    return {
      query: {
        page: 1,
        limit: 10,
        terminal_id: "",
        box_name: "",
      },
      dialogTitle: "新增",
      total: 0,
      dialogVisible: false,
      list: [],
      editId: null,
      form: {
        terminal_id: "",
        box_name: "",
        company_id: "",
        company_name: "",
      },
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    getList() {
      axios.get("/pc/company-cam-box/list", this.query).then((res) => {
        if (res.code == 200) {
          this.list = res.data.cam_box_list;
          this.total = res.data.pager_count;
        }
      });
    },
    onSubmit() {
      this.query.page = 1;
      this.getList();
    },
    pageChange(page) {
      this.query.page = page;
      this.getList();
    },
    add() {
      this.dialogTitle = "新增";
      this.dialogVisible = true;
    },
    handleEdit(row) {
      this.editId = row.id;
      this.form.terminal_id = row.terminal_id;
      this.form.box_name = row.box_name;
      this.form.company_id = row.company_id;
      this.form.company_name = row.company_name;
      this.dialogTitle = "修改";
      this.dialogVisible = true;
    },
    resetForm() {
      this.editId = null;
      this.form = {
        terminal_id: "",
        box_name: "",
        company_id: "",
        company_name: "",
      };
      this.$nextTick(() => {
        if (this.$refs.form) {
          this.$refs.form.clearValidate();
        }
      });
    },
    delItem(row) {
      axios.delete(`/pc/company-cam-box/delete/${row.id}`).then((res) => {
        if (res.code === 200) {
          if (this.list.length === 1 && this.query.page > 1) {
            this.query.page--;
          }
          this.getList();
        }
      });
    },
    // 根据企业名称查询信息，沿用公共企业搜索接口。
    querySearchAsync(queryString, cb) {
      if (queryString) {
        axios
          .get("/pc/company/signList/2", {
            company_name: queryString,
          })
          .then((response) => {
            cb(response.data.company_list);
          })
          .catch(() => {
            cb([]);
          });
      } else {
        cb([]);
      }
    },
    clearCompany() {
      this.form.company_id = "";
    },
    handleSelect(item) {
      this.form.company_id = item.company_id;
      this.form.company_name = item.company_name;
      this.$refs.form.clearValidate("company_id");
    },
    submit() {
      this.$refs.form.validate((valid) => {
        if (!valid) {
          return false;
        }
        const data = {
          terminal_id: this.form.terminal_id,
          box_name: this.form.box_name,
          company_id: this.form.company_id,
          company_name: this.form.company_name,
        };
        if (this.dialogTitle === "新增") {
          axios.post("/pc/company-cam-box/save", data).then((res) => {
            if (res.code == 200) {
              this.getList();
              this.dialogVisible = false;
            }
          });
        } else {
          axios
            .post("/pc/company-cam-box/update", {
              id: this.editId,
              ...data,
            })
            .then((res) => {
              if (res.code == 200) {
                this.getList();
                this.dialogVisible = false;
              }
            });
        }
      });
    },
  },
};
</script>
